import styles from './wordmark.module.scss'

export function Wordmark() {
  return (
    <div className={styles.wordmark}>
      Politech <span className={styles.faded}>Check-ins</span>
    </div>
  )
}
